import { Spinner } from '@/components/Spinner';
import { useMainPageShuffle } from '../hooks/useMainPageShuffle';
import { SetShuffleForm } from './SetShuffleForm';

export const SetShuffleFormContainer = ({ canUpdateShuffleTime }: { canUpdateShuffleTime: boolean }) => {
  const { mainPageShuffle, isLoading } = useMainPageShuffle();
  const top5Data = mainPageShuffle?.find((s) => s.displayName === 'Top 5');
  const remaining20Data = mainPageShuffle?.find((s) => s.displayName === 'Remaining 20');
  const groupShuffleData = mainPageShuffle?.find((s) => s.displayName === 'Shuffling Time');
  const defaultValues = {
    top5: top5Data?.displayTime ?? '',
    remaining20: remaining20Data?.displayTime ?? '',
    groupShuffle: groupShuffleData?.displayTime ?? '',
  };
  return isLoading ? (
    <Spinner />
  ) : (
    <SetShuffleForm defaultValues={defaultValues} canUpdateShuffleTime={canUpdateShuffleTime} />
  );
};
